export const GET_REQUEST = 'plan/GET_REQUEST';
export const GET_SUCCESS = 'plan/GET_SUCCESS';
export const GET_FAILURE = 'plan/GET_FAILURE';
export const POST_REQUEST = 'plan/POST_REQUEST';
export const POST_SUCCESS = 'plan/POST_SUCCESS';
export const POST_FAILURE = 'plan/POST_FAILURE';

export const UPDATE_PLAN = 'plan/UPDATE_PLAN';
export const UPDATE_UPGRADE_LIST = 'plan/UPDATE_UPGRADE_LIST';